import Vuex, { MutationPayload } from 'vuex';
import Vue from 'vue';
import { themes, State as themeState } from './modules/themes';
import { chargingData, State as chargingDataState } from './modules/charging-data';
import { config, State as configState, Locale } from './modules/config';
import { EuropeTracking } from './EuropeTracking';
import { tracking } from './modules/tracking-stub';
import { Tracking } from './AbstractTracking';
import { UsaTracking } from './UsaTracking';
Vue.use(Vuex);
import { Subject } from 'rxjs';
import { debounceTime } from 'rxjs/operators';
export type Action<T, R = void> = (param: T) => R;

export enum Modules {
  themes = 'themes',
  chargingData = 'chargingData',
  config = 'config',
  tracking = 'tracking',
}
export interface Store {
  themes: themeState;
  chargingData: chargingDataState;
  config: configState;
}
export const store = new Vuex.Store<Store>({
  modules: {
    themes,
    chargingData,
    config,
    tracking,
  },
});

/**
 * Use rxjs subject for prevent multiple tracking subscriptions (e.g. en and de are set on page load)
 */
const localeChangeTracker = new Subject<string>();
localeChangeTracker.pipe(debounceTime(150)).subscribe((country) => {
  let tracking: Tracking<any, any>;
  switch (country) {
    case 'DE':
      tracking = new EuropeTracking();
      break;
    case 'US':
      tracking = new UsaTracking();
      break;
    default:
      tracking = new EuropeTracking();
  }

  store.subscribe(tracking.trackMiddleware);
});

const initializeTracking = async (mutation: MutationPayload, state: Store) => {
  if (mutation.type === 'config/setLocale') {
    const data: Locale = mutation.payload;
    localeChangeTracker.next(data.country);
  }
};

store.subscribe(initializeTracking);
